(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phase-selector"] && !Shopify.designMode) return;
  try {
    
  class PhaseSelector extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('[role="tablist"]');
      this.panels = [];
      this.tabs = [];
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.phase-selector__panel'));
      if (this.panels.length === 0) return;

      this.panels.forEach((panel, index) => {
        const label = panel.dataset.tabLabel || String(index + 1);
        const tab = document.createElement('button');
        tab.className = 'phase-selector__tab';
        tab.textContent = label;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
        this.tabList.appendChild(tab);
        this.tabs.push(tab);

        panel.setAttribute('aria-labelledby', tab.id);
        if (index !== 0) panel.hidden = true;
      });

      if (this.tabs.length > 0) this.tabs[0].classList.add('phase-selector__tab--active');
    }

    activate(index) {
      this.tabs[this.activeIndex].classList.remove('phase-selector__tab--active');
      this.tabs[this.activeIndex].setAttribute('aria-selected', 'false');
      this.tabs[this.activeIndex].setAttribute('tabindex', '-1');
      this.panels[this.activeIndex].hidden = true;

      this.activeIndex = index;
      this.tabs[index].classList.add('phase-selector__tab--active');
      this.tabs[index].setAttribute('aria-selected', 'true');
      this.tabs[index].setAttribute('tabindex', '0');
      this.panels[index].hidden = false;
    }

    handleKeydown(e, index) {
      let next = index;
      if (e.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      else if (e.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = this.tabs.length - 1;
      else return;
      e.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }
  }

  customElements.define('phase-selector', PhaseSelector);

  } catch(e) { console.error(e); }
})();
})();
